// extracted by mini-css-extract-plugin
export default {"section":"ButtonsEdit_section__PDW71","previewContainer":"ButtonsEdit_previewContainer__-cj8q"};